/**
 * stateChangeOnlyActionTypeCreator   -> Should be used only for UI State Change. Assuming that UI State change doesn't require Loading/Success/Reset actions
 * REQUEST        -> Should be used only in case of API Calls
 * LOADING        -> Transition State
 * SUCCESS        -> Used when action is handled completely
 * FAILURE        -> When action failed
 * RESET          -> When reset action is needed
 */
import { REQUEST_ACTION_TYPE_SUFFIX, SUCCESS_ACTION_TYPE_SUFFIX, FAILURE_ACTION_TYPE_SUFFIX } from './constants';

export const actionTypeCreator = action => ({
  REQUEST: `${action}${REQUEST_ACTION_TYPE_SUFFIX}`,
  LOADING: `${action}_LOADING`,
  SUCCESS: `${action}${SUCCESS_ACTION_TYPE_SUFFIX}`,
  FAILURE: `${action}${FAILURE_ACTION_TYPE_SUFFIX}`,
  RESET: `${action}_RESET`,
});

export const stateChangeOnlyActionTypeCreator = action => ({
  TRIGGER: `${action}_UPDATE_TRIGGER`,
  COMPLETED: `${action}_UPDATE_STATE_COMPLETED`,
  FAILED: `${action}_UPDATE_STATE_FAILURE`,
});

export const actionCreator = actionType => ({
  Request: reqData => ({ payload: reqData, type: actionType.REQUEST }),
  Loading: status => ({ type: actionType.LOADING, payload: status }),
  Success: resData => ({ payload: resData, type: actionType.SUCCESS }),
  Failure: (error, payload) => ({ error, payload, type: actionType.FAILURE }),
  Reset: () => ({ type: actionType.RESET }),
});

export const stateChangeOnlyActionCreator = actionType => ({
  Trigger: reqData => ({ payload: reqData, type: actionType.TRIGGER }),
  Completed: reqData => ({ payload: reqData, type: actionType.COMPLETED }),
  Failed: (error, payload) => ({ error, payload, type: actionType.FAILED }),
});
